import React from "react";
import "./GetMusicOnSoundCloud.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnSoundCloud = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music",
    "Select SoundCloud distribution",
    "Music delivered to SoundCloud",
    "Reach global listeners",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>SoundCloud Music Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music on SoundCloud with FT Tunes. Reach millions of listeners, grow fans and monetize your tracks worldwide."
        />

        <meta
          name="keywords"
          content="SoundCloud distribution, upload music to SoundCloud, SoundCloud music release, FT Tunes distribution"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="soundcloud-page">

        {/* HERO */}
        <section className="soundcloud-hero">
          <Container>

            <img
              src="/Images/sound-cloud-logo.png"
              alt="SoundCloud"
              className="soundcloud-logo"
            />

            <h1>Distribute Your Music on SoundCloud</h1>

            <p>
              Upload your tracks to SoundCloud and connect with one of
              the world’s largest music communities. Grow your audience,
              promote releases and build your fanbase globally.
            </p>

            <Button
              className="gradient-btn-sc"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-sc"></div>
        </section>


        {/* SHOWCASE */}
        <section className="soundcloud-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Millions on SoundCloud</h2>

                <p>
                  SoundCloud empowers independent artists to share music
                  instantly with fans worldwide. Upload your songs,
                  gain exposure and grow your streaming presence.
                </p>

                <Button
                  className="outline-btn-sc"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-sound-cloud.png"
                  alt="Get Music On SoundCloud"
                  className="soundcloud-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="soundcloud-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-sc">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="soundcloud-benefits">
          <Container>

            <h2 className="section-title">
              Why Release Music on SoundCloud
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-sc">
                  <h5>Global Community</h5>
                  <p>Connect with millions of music lovers.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-sc">
                  <h5>Independent Artist Power</h5>
                  <p>Perfect platform for emerging artists.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-sc">
                  <h5>Instant Releases</h5>
                  <p>Publish music quickly worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-sc">
                  <h5>Monetization</h5>
                  <p>Earn revenue from streams & fans.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="soundcloud-cta">
          <Container>

            <h2>Start Your SoundCloud Journey Today</h2>

            <Button
              className="gradient-btn-sc big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnSoundCloud;